module.exports = __webpack_public_path__ + "static/media/TanggulaPass.b1ae26d0.jpg";